import { useQuery } from '@tanstack/react-query';
import { makeDashboardApi } from '../DashboardApi';
import { AxiosError, AxiosResponse } from 'axios';
import { ICrmMetricsRequest, ICrmMetricsResponse } from '../types';

export const useCrmMetrics = (request: ICrmMetricsRequest) => {
  const crmMetrics = useQuery<AxiosResponse<ICrmMetricsResponse>, AxiosError>({
    queryKey: ['crm-metrics', request],
    queryFn: () => {
      return makeDashboardApi().getCrmMetrics(request);
    },
    retry: false,
  });

  return {
    crmMetricsData: crmMetrics.data?.data,
    isLoadingCrmMetrics: crmMetrics.isLoading,
    isErrorCrmMetrics: crmMetrics.isError,
  };
};
